import { render, staticRenderFns } from "./personalAdd.vue?vue&type=template&id=e9d164d4&scoped=true"
import script from "./personalAdd.vue?vue&type=script&lang=js"
export * from "./personalAdd.vue?vue&type=script&lang=js"
import style0 from "./personalAdd.vue?vue&type=style&index=0&id=e9d164d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d164d4",
  null
  
)

export default component.exports